export const IMAGE_CDN_URL = "https://cdn.apixbet.com/app/images";
export const TRY_TO_PLAY_CASINO_IMG =
  "https://wallpaperaccess.com/full/1633753.jpg";
export const TRY_TO_PLAY_SLOT_IMG =
  "https://jokerauto.net/wp-content/uploads/2021/05/966545121.jpg";
export const TRY_TO_PLAY_FISHING_IMG =
  "https://pbs.twimg.com/media/EyggkD0VEAE0fld.png:large";
